/*@flow*/
/** @jsx jsx */
import { Popover } from 'react-bootstrap';
import OverlayTriggerWrapper from 'comps/OverlayTriggerWrapper';
import { css, jsx } from '@emotion/core';
import ProgressModal from './ProgressModal';
import { type ProgressResponse } from '../';
import hideDialog from '../hideDialog';
import React from 'react';

type InputPropsT = {
  allSelected: boolean,
  actionStarted: boolean,
  canDestroy: boolean,
  jobId: ?string,
  onDestroyProgress: string => Promise<ProgressResponse>,
  onDestroyConfirmed: Function,
};

export default (props: InputPropsT) => (
  <React.Fragment>
    <OverlayTriggerWrapper
      trigger="click"
      rootClose
      placement="right"
      overlay={
        <Popover id="confirm-destroy">
          <div>
            <p className="text-center">Are you sure?</p>
            <div css={css('display: grid; grid-template-columns: 1fr 1fr;')}>
              <button
                css={css('&:focus { outline: none !important; }')}
                className="btn btn-link"
                onClick={props.onDestroyConfirmed}
              >
                Yes
              </button>
              <button
                className="btn btn-danger"
                css={css(
                  'color: white !important; &:hover { background: red !important; }'
                )}
                onClick={() => {
                  hideDialog();
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </Popover>
      }
    >
      <button
        disabled={!props.canDestroy}
        css={css(props.canDestroy ? 'color: #d9534f;' : 'color: #ccc;')}
      >
        <i className="fa fa-trash" /> Delete{' '}
        {props.allSelected ? 'all' : 'selected'}
      </button>
    </OverlayTriggerWrapper>
    <ProgressModal
      isOpen={props.actionStarted}
      onProgress={() => {
        if (props.jobId) {
          return props.onDestroyProgress(props.jobId);
        }
        throw new Error('Something went wrong.');
      }}
      onClose={() => {
        // props.update({ actionStarted: false });
        // props.onClear();
      }}
    />
  </React.Fragment>
);
